<template>
    <div
        class="w-full h-full flex justify-center bg-neutral-0 text-base tracking-normal rounded-b-xl" 
    >
        <!-- <div
            class="flex flex-col w-[200px] h-full border-r border-neutral-2  bg-neutral-1 tracking-wider text-neutral-7 rounded-bl-xl"
        >
            <div
                @click="chooseUploadMethod('dropbox')"
                class="p-2 mt-4 rounded-md cursor-pointer"
                :style="dropBoxStyle"
            >
                <div>

                </div>
                <div>
                    Dropbox
                </div>
            </div>
            <div
                @click="chooseUploadMethod('externalLink')"
                class="p-2 rounded-md cursor-pointer"
                :style="linkStyle"
            >
                <div></div>
                <div>Link (URL)</div>
            </div>
        </div> -->
        <div
            class="flex w-full h-full"
        >
            <div
                v-if="uploadMethod=='dropbox'"
                class="w-full h-full"
            >
                <DropboxChooser
                    @upload-dropbox-files="uploadFileAttachments"
                />
            </div>
            <div v-else
                class="w-full h-full"
            >
                <UploadLinks
                    @upload-links="uploadFileAttachments"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, defineEmits } from 'vue';
import UploadLinks from '@/components/base-components/UploadLinks.vue';
import DropboxChooser from '@/components/base-components/DropboxChooser.vue';

const emit = defineEmits(['upload-file-attachments'])

const uploadMethod = ref('dropbox')

const dropboxStyle = computed(() => {
    if(uploadMethod.value=='drobox') {
        return 'background-'
    } else {
        return ''
    }
})

const linkStyle = computed(() => {
    if(uploadMethod.value=='externalLink') {
        return ''
    } else {
        return ''
    }
})

function chooseUploadMethod(methodName) {
    uploadMethod.value = methodName
}

function uploadFileAttachments(attachments) {
    console.log('Uploader: uploadFileAttachments')
    emit('upload-file-attachments', attachments)
}


</script>